import { euroFormatterIt } from 'app/src/shared/helpers'
import manWithSmartphone from 'app/static/images/man_smartphone_star.png'
import { Card } from 'primereact/card'
import { Image } from 'primereact/image'
import { type ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

export function ConvertCard(
  props: Readonly<{ convertedPercentage: number; accountConvert?: number; nettoConvertitoInWelfare?: number }>,
): ReactElement {
  const { t } = useTranslation('joinFunnel', { keyPrefix: 'JoinFunnel.FirstStep' })
  const tCommon = useTranslation('joinFunnel', { keyPrefix: 'JoinFunnel.Common' })
  return (
    <>
      <Card className='pl-16 pr-16 text-center'>
        <div className='h-48 flex-grow place-self-center'>
          <Image src={manWithSmartphone} width='246' alt='Immagine di un uomo con smartphone'></Image>
        </div>
        <div>
          <div
            className='rounded-3xl bg-[var(--primary-color)] p-4 text-white'
            dangerouslySetInnerHTML={{
              __html: t('convertCard.buttonText', { PERCENTAGE: `${(props.convertedPercentage * 100)?.toFixed(1)}%` }),
            }}
          ></div>
          <div className='mt-2 h-12 flex-grow'>{t('convertCard.textBeforeFigure')}</div>
          <div className='text-[50px] font-semibold text-[var(--primary-color)]'>
            {props.accountConvert ? euroFormatterIt.format(props.accountConvert) : tCommon.t('notAvailableText')}
          </div>
          {props.convertedPercentage === 1 ? (
            <div
              dangerouslySetInnerHTML={{
                __html: t('convertCard.textAfterFigure'),
              }}
            ></div>
          ) : (
            <div className='h3'>
              {t('convertCard.netAmountConvertedIntoWelfare')}
              {props.nettoConvertitoInWelfare
                ? euroFormatterIt.format(props.nettoConvertitoInWelfare)
                : tCommon.t('notAvailableText')}
            </div>
          )}
        </div>
      </Card>
    </>
  )
}
